import styles from './ContractData.module.scss'

interface IProps {
  value: string | number | null
  label?: string
}

export const ReadOnlyField = ({ value, label }: IProps) => {
  return (
    <div className={styles.readOnly}>
      {label ? <div className={styles.title}>{label}:</div> : null}
      <div className={styles.value}>{value ?? <span>&#8213;</span>}</div>
    </div>
  )
}
